import type { UpdateUserEmailBody } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";
import type { WretchResponse } from "wretch";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { profileKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useUpdateUserEmail(
  userId: string,
): UseMutationResult<WretchResponse, Error, UpdateUserEmailBody> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateUserEmailBody) =>
      apiClient.url(`/users/${userId}/email`).patch(data).res(),
    onError: () => {
      toast.add({
        description: "Failed to update email",
        timeout: 3000,
        type: "error",
      });
    },
    onSuccess: () => {
      toast.add({
        description: "Email updated successfully",
        timeout: 3000,
        type: "success",
      });
      queryClient.invalidateQueries({ queryKey: profileKeys.userById(userId) });
    },
  });
}
